export const ROUTES = {
  relevanceReview: {
    parentPath: "/clinical-coding",
    slug: "relevance-review",
    route: "/clinical-coding/relevance-review",
  },
};
